import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { MatSlideToggle, MatSlideToggleChange } from "@angular/material/slide-toggle";
import { fuseAnimations } from "@fuse/animations";
import { ClienteDTO } from "app/main/apps/shared/interfaces/cliente.interface";
import { ClienteService } from "app/main/apps/shared/services/rest/cliente.service";
import { Subscription } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Component({
    selector: "app-ficha-cliente",
    templateUrl: "./ficha-cliente.component.html",
    styleUrls: ["./ficha-cliente.component.scss"],
})
export class FichaClienteComponent implements OnInit, OnDestroy {
    @Input() data: ClienteDTO;
    @Output() eliminarCliente: EventEmitter<any> = new EventEmitter();
    @Output() editarCliente: EventEmitter<any> = new EventEmitter();
    @Output() toggleEstadoClienteEvent: EventEmitter<ClienteDTO> = new EventEmitter();

    @ViewChild("checkActivacion", { static: false })
    slideActivacion: MatSlideToggle;

    subscripciones: Subscription;
    constructor(private _clienteSrvc:ClienteService) {
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
    }

    eliminar(cliente) {
        this.eliminarCliente.emit(cliente);
    }

    editar(cliente) {
        this.editarCliente.emit(cliente);
    }

    toggleEstadoCliente(cliente:ClienteDTO) {
        this.toggleEstadoClienteEvent.emit(cliente);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.evaluaActivacion();
        });

        this.subscripciones.add(
            this._clienteSrvc.clienteStatusChanged$
            .subscribe((resp) => {
                this.data=resp;
                this.evaluaActivacion();
            })
        )
    }

    evaluaActivacion() {
        this.slideActivacion.checked = this.data.fechaTermino == null ? true : false;
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
